import { ColumnType } from '@uhg-uicl/ui-core/dist/Organisms/Grid/types';

// Document type configuration
export const docTypeHierarchy: { [key: string]: number } = {
  "Appeal Letter": 1,
  "Patient Letter": 1,
  "Patient Letter With Override Address": 1,
  "Payer Dispute Form": 1,
  "Payer Letter": 1,
  "Cover Letter": 1,
  "Ambulance Report": 2,
  "EOB": 2,
  "IZ Statement": 2,
  "Package": 1,
  "Other": 2,
  "Rate Sheet": 2,
  "W9 Form": 2,
  "Non Medical Record": 2,
  "Medical Record": 2,
  "Copy of Claim": 2,
};

export const packageTypes: { [key: string]: string } = {
  "Medical Record": "PKG",
  "Non Medical Record": "NMR",
  "Cover Letter": "CVRLTR",
  "EOB": "PYRLTR",
  "Patient Letter With Override Address": "BRE",
  "Patient Letter": "PTLTR",
  "Appeal Letter": "APL",
  "Package": "PKG",
  "Rate Sheet": "APL",
  "Payer Letter": "PYRLTR",
};

export const columns: Set<ColumnType> = new Set([
  { dataName: 'documentType', text: 'Document Type', sortable: true, isSorted: 0 },
  { dataName: 'actualFileName', text: 'Actual File', sortable: true, isSorted: 0 },
  { dataName: 'fileName', text: 'File', sortable: true, isSorted: 0 },
]);

export const docTypeOptions = [
  { label: 'Ambulance Report', value: 'Ambulance Report' },
  { label: 'Appeal Letter', value: 'Appeal Letter' },
  { label: 'Copy of Claim', value: 'Copy of Claim' },
  { label: 'EOB', value: 'EOB' },
  { label: 'IZ Statement', value: 'IZ Statement' },
  { label: 'Medical Record', value: 'Medical Record' },
  { label: 'Package', value: 'Package' },
  { label: 'Patient Letter', value: 'Patient Letter' },
  { label: 'Patient Letter With Override Address', value: 'Patient Letter With Override Address' },
  { label: 'Payer Dispute Form', value: 'Payer Dispute Form' },
  { label: 'Payer Letter', value: 'Payer Letter' },
  { label: 'Rate Sheet', value: 'Rate Sheet' },
  { label: 'W9 Form', value: 'W9 Form' },
  { label: 'Other', value: 'Other' },
];

export const clientDocTypeOptions: { [key: string]: typeof docTypeOptions } = {
  Dignity: docTypeOptions,
};

export function getDocTypeOptionsForClient(clientName: string): typeof docTypeOptions {
  return clientDocTypeOptions[clientName] || docTypeOptions;
}

export const mailTypeOptions = [
  { label: 'Certified-CERT', value: 'CERT' },
  { label: 'Standard-STD', value: 'STD' },
];

export function getPackageAbbreviation(key: string, requestType: string): string {
  if (packageTypes[key]) return packageTypes[key];
  if (
    key === 'Payer Dispute Form' ||
    key === 'Ambulance Report' ||
    key === 'Copy of Claim' ||
    key === 'W9 Form' ||
    key === 'Other' ||
    key === 'IZ Statement'
  ) {
    if (requestType === 'Payer') return 'PYRLTR';
    if (requestType === 'Patient') return 'PTLTR';
    return 'PYRLTR';
  }
  return 'PYRLTR';
}
